import React from 'react';
import styled from 'styled-components';

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 20px;
  position: relative;
  gap: 20px;

  @media (max-width: 845px) {
    padding: 16px;
    gap: 16px;
  }

  .updateButton {
    padding: 15px 50px;
    border-radius: 3.2px;
    background-color: #fafafa;
    max-width: 300px;
    text-align: center;
    position: absolute;
    right: 1vw;
    margin-right: -5px;
    top: 5px;
    border: none;
    width: 218px;
  }

  .updateButton > p {
    color: #4a4a4a;
    font-size: 13.6px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.47;
    letter-spacing: normal;
    text-align: center;
  }

  .adminCardFooter {
    position: relative;
    height: 60px;
    display: flex;
    width: 100%;
  }

  .adminCardFooter .preferencesUpdateButton {
    margin-left: auto;
    margin-right: 50px;
    width: 218px;
    height: 45px;
    border-radius: 3.2px;
    background-color: #fafafa;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 13.6px;
    font-weight: bold;
    text-align: center;
    color: #4a4a4a;
  }
`;

const Card = (props) => {
  return <StyledCard {...props}>{props.children}</StyledCard>;
};

export default Card;
